import React, { ElementType, forwardRef } from "react";
import { ButtonProps } from "./Button.types";
import { getClassName } from "../../helpers/common.helpers";
import "./ButtonComponent.scss";

const ButtonComponent = forwardRef(<T extends ElementType = "button">({ as, variant = "primary", type = "button", size = "medium", disabled = false, buttonClassName = "", children, ...rest }: ButtonProps<T>, ref: any): JSX.Element => {

    const Component: ElementType = as ?? "button";

    return <Component ref={ref} className={getClassName(`${type}-${variant} ${type}-${size}`, buttonClassName)} disabled={disabled} {...rest}>{children}</Component>
});

export default ButtonComponent;
